import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Booking } from 'happypaws-shared/src/Booking/models/Booking';
import { CreateBookingRequest } from 'happypaws-shared/src/Booking/models/CreateBookingRequest';
import { api } from '../../services/api';

export const useCreateBooking = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateBookingRequest) => {
      const response = await api.post<Booking>('/bookings', data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientBookings'] });
    },
  });
};
